// extracted by mini-css-extract-plugin
module.exports = {"list":"FormDate_list__vdUGa","rotation":"FormDate_rotation__xtZg_"};